module.exports = __webpack_public_path__ + "static/media/ic_share_disable.b150b8ec.svg";